// extracted by mini-css-extract-plugin
export default {"navigation":"ypFpX4","secondary":"jhoOZs"};